module cr.entity {
    class entityHomeController {
        constructor(
            private $scope,
            currentUser: cr.account.ICurrentUser,
            userPermission:cr.account.IUserPermission,
            private moduleList:Array<EntityModuleView>,
            private $state:any) {
            $scope.context='Entity';

            $scope.userPermission=userPermission;
            $scope.moduleList=moduleList;
            $scope.SelectModule=(moduleName:string)=>{
                console.log("module: "+moduleName);
                $state.go("entity.module",{ moduleName: moduleName });
            }
       }
    }

    // Module registrations.
    entityModule.controller('entityHomeController', ['$scope','currentUser','userPermission','moduleList','$state', entityHomeController]);

}
